
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/power-of-zero",
      function () {
        return require("private-next-pages/power-of-zero.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/power-of-zero"])
      });
    }
  